import React from 'react'
import styles from './BlockCaption.scss'
import cx from 'classnames'
import Textarea from 'react-textarea-autosize'
import { defineMessages, injectIntl } from 'react-intl'

const message = defineMessages({
  caption: {
    id: 'BlockCaption.caption',
    defaultMessage: 'Write a caption'
  }
})

class _BlockCaption extends React.Component {
  updateCaption = (e) => {
    this.props.blockProps.onChange({ caption: e.target.value })
  }

  onKeyDown = (e) => {
    // up/down arrows now handled by letting key events fall through to parent
    const DELETE = 8

    if (e.keyCode === DELETE) {
      // prevent hitting backspace in a caption from deleting blocks
      e.stopPropagation()
    }
  }

  render () {
    const { intl } = this.props
    const data = this.props.block.getData()
    const caption = data.get('caption')
    const captionEmpty = !caption || caption.length === 0
    const captionClass = cx(styles.BlockCaption, captionEmpty && styles.placeholder)

    return (
      <figcaption className={captionClass} onKeyDown={this.onKeyDown}>
        <Textarea
          contentEditable='true'
          suppressContentEditableWarning
          value={caption || ''}
          placeholder={intl.formatMessage(message.caption)}
          onChange={this.updateCaption}
          className={styles.textarea} />
        <div className={styles.closeButton} />
      </figcaption>
    )
  }
}

export const BlockCaption = injectIntl(_BlockCaption)
